function contains(attrName, value, everywhere) {
    if (everywhere) {   // kdekoli
        return inputLength === 0 ? [] : list.filter(item =>
                item[attrName].toLowerCase().indexOf(inputValue) >= 0
            );
    } else {    // jen od začátku
        return inputLength === 0 ? [] : list.filter(item =>
                item[attrName].toLowerCase().slice(0, inputLength) === inputValue
            );
    }
}

// attrName může být jak string, tak array
export default function filterObjectsByPropertyFulltext(list, value, attrName = 'name', everywhere = true) {
    if (value === null || value.length === 0) {
        return list;
    }

    const inputValue = value.trim().toLowerCase();
    if (inputValue.length === 0) {
        return list;
    }

    const inputLength = inputValue.length;

    if (everywhere) {   // kdekoli
        return list.filter(item => {
            if (typeof attrName === "string") {
                return item[attrName] && item[attrName].toLowerCase().indexOf(inputValue) >= 0
            } else {
                for (let a=0; a<attrName.length; a++) {
                    if (item[attrName[a]] && item[attrName[a]].toLowerCase().indexOf(inputValue) >= 0) {
                        return true;
                    }
                }
                return false;
            }
        });
    } else {    // jen od začátku
        return list.filter(item => {
            if (typeof attrName === "string") {
                return item[attrName].toLowerCase() && item[attrName].toLowerCase().indexOf(inputValue) === inputValue
            } else {
                for (let a=0; a<attrName.length; a++) {
                    if (item[attrName[a]] && item[attrName[a]].toLowerCase().indexOf(inputValue) === inputValue) {
                        return true;
                    }
                }
                return false;
            }
        });
    }
}
